module.exports = __webpack_public_path__ + "img/searchSermons.8e2ca0b6.png";